import React from 'react';
import {useQuery} from "@tanstack/react-query";
import axios from "axios";
import {extractAccessToken} from "../helpers/jwt";
import {ResponseEmployee} from "../models/config/Employee";

export type WithEmployeeInfoProps = {
    employeeInfo?: ResponseEmployee['result_list'];
};

export function withEmployeeInfo<T extends WithEmployeeInfoProps>(
    WrappedComponent: React.ComponentType<T>
) {
    const displayName =
        WrappedComponent.displayName || WrappedComponent.name || 'Component';

    const ComponentWithEmployeeInfo = (
        props: Omit<T, keyof WithEmployeeInfoProps>
    ) => {
        const { data: employeeInfo } = useQuery({
            queryKey: ['employee-info'],
            queryFn: ({ signal }) => {
                const userInformation = extractAccessToken();
                const accessToken = localStorage.getItem('LG_APPLICATION');
                return axios.get<ResponseEmployee>('/v1/user', {
                    signal,
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                    params: {
                        id: userInformation?.citizen_id || userInformation?.username || '',
                    }
                });
            },
            refetchOnWindowFocus: false,
            retry: 1,
            select: response => response.data.result_list
        });

        return (
            <WrappedComponent
                employeeInfo={employeeInfo}
                {...(props as T)}
            />
        );
    };

    ComponentWithEmployeeInfo.displayName = `withAdminCompanies(${displayName})`;

    return ComponentWithEmployeeInfo;
}
